import React from "react";
import { Wrench, Sparkles, ShieldCheck, PackageOpen, ArrowRight } from "lucide-react";
import { services, stats } from "../mock";
import { Link } from "react-router-dom";

const iconMap = { Wrench, Sparkles, ShieldCheck, PackageOpen };

const Services = () => {
  return (
    <section className="py-20 bg-white" id="servizi">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <span className="text-[#00A859] text-sm font-bold uppercase tracking-[3px] mb-3 block">
              I nostri servizi
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0B2545] tracking-tight leading-[1.05] mb-5">
              Un partner unico per la tua azienda
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Oltre alla fornitura di prodotti, offriamo una gamma completa di
              servizi tecnici e operativi pensati per le esigenze delle
              aziende: manutenzione, pulizia, portierato e facchinaggio.
            </p>
            <Link
              to="/servizi"
              className="inline-flex items-center gap-2 bg-[#0B2545] hover:bg-[#0a1f3d] text-white font-bold px-6 py-3.5 rounded-full text-sm uppercase tracking-wide transition-all"
            >
              Richiedi un preventivo <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="bg-gray-50 border border-gray-100 rounded-xl p-6 hover:border-[#00A859] hover:shadow-md transition-all"
              >
                <div className="text-4xl font-extrabold text-[#00A859] mb-1">
                  {s.value}
                </div>
                <div className="text-sm text-gray-600 font-medium">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.title}
                className="group bg-white border border-gray-200 hover:border-[#00A859] rounded-2xl p-7 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-[#00A859]/10 group-hover:bg-[#00A859] flex items-center justify-center mb-5 transition-colors">
                  <Icon className="w-7 h-7 text-[#00A859] group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-lg font-bold text-[#0B2545] mb-2">
                  {s.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {s.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
